import { defineComponent as _defineComponent } from 'vue'
import { resolveComponent as _resolveComponent, createVNode as _createVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, createElementVNode as _createElementVNode, withCtx as _withCtx, resolveDirective as _resolveDirective, openBlock as _openBlock, createBlock as _createBlock, withDirectives as _withDirectives } from "vue"

const _hoisted_1 = /*#__PURE__*/_createTextVNode(" Удалить")

import { PropType } from 'vue';
import { Facility } from '@/components/facility/types';


export default /*#__PURE__*/_defineComponent({
  __name: 'MenuAbstract',
  props: {
  node: Object as PropType<Facility>,
},
  emits: ['showModal'],
  setup(__props, { emit }) {

const props = __props



const popupHandler = (action: string) => {
  emit('showModal', props.node, action);
};

return (_ctx: any,_cache: any) => {
  const _component_q_icon = _resolveComponent("q-icon")!
  const _component_q_item_section = _resolveComponent("q-item-section")!
  const _component_q_item = _resolveComponent("q-item")!
  const _component_q_separator = _resolveComponent("q-separator")!
  const _component_q_list = _resolveComponent("q-list")!
  const _component_q_menu = _resolveComponent("q-menu")!
  const _directive_close_popup = _resolveDirective("close-popup")!

  return (_openBlock(), _createBlock(_component_q_menu, {
    "touch-position": "",
    "context-menu": ""
  }, {
    default: _withCtx(() => [
      _createVNode(_component_q_list, {
        dense: "",
        style: {"min-width":"100px"}
      }, {
        default: _withCtx(() => [
          _withDirectives((_openBlock(), _createBlock(_component_q_item, { clickable: "" }, {
            default: _withCtx(() => [
              _createVNode(_component_q_item_section, {
                onClick: _cache[0] || (_cache[0] = ($event: any) => (popupHandler("add")))
              }, {
                default: _withCtx(() => [
                  _createElementVNode("span", null, [
                    _createVNode(_component_q_icon, { name: "add" }),
                    _createTextVNode(" Добавить " + _toDisplayString(props.node?.field_child_alias), 1)
                  ])
                ]),
                _: 1
              })
            ]),
            _: 1
          })), [
            [_directive_close_popup]
          ]),
          _withDirectives((_openBlock(), _createBlock(_component_q_item, { clickable: "" }, {
            default: _withCtx(() => [
              _createVNode(_component_q_item_section, {
                onClick: _cache[1] || (_cache[1] = ($event: any) => (popupHandler("confirmRemove")))
              }, {
                default: _withCtx(() => [
                  _createElementVNode("span", null, [
                    _createVNode(_component_q_icon, { name: "delete" }),
                    _hoisted_1
                  ])
                ]),
                _: 1
              })
            ]),
            _: 1
          })), [
            [_directive_close_popup]
          ]),
          _createVNode(_component_q_separator),
          _withDirectives((_openBlock(), _createBlock(_component_q_item, { clickable: "" }, {
            default: _withCtx(() => [
              _createVNode(_component_q_item_section, null, {
                default: _withCtx(() => [
                  _createVNode(_component_q_icon, {
                    name: "cancel",
                    class: "q-mx-auto"
                  })
                ]),
                _: 1
              })
            ]),
            _: 1
          })), [
            [_directive_close_popup]
          ])
        ]),
        _: 1
      })
    ]),
    _: 1
  }))
}
}

})